import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { getServices, createTenant, createTenantServices, getAdminInvitations, getTenantProducts, updateTenant, updateTenantProducts, setSelectedServices } from '../../actions/services';
import { getTenant, addUser, getBaseMe, userAdminCheck } from 'actions/user';
import { Spinner } from 'UI';
import ServiceSelector from './Step1/ServiceSelector';
import Wizard from 'containers/Wizard/Wizard';
import WizardStep from 'containers/Wizard/WizardStep';
import ConsentManager from './ConsentManager';
import TermsManagemant from './TermsManagemant';
import getEnvironment from 'lib/env';
import { setPageTitle } from "actions/header";
import ConsentConfirm from './Step4/ConsentConfirm';
import { appInsights } from 'lib/appInsights';
import * as microsoftTeams from "@microsoft/teams-js";

var IndexWrapper = /*#__PURE__*/function (_Component) {
  _inherits(IndexWrapper, _Component);

  var _super = _createSuper(IndexWrapper);

  function IndexWrapper(props) {
    var _this;

    _classCallCheck(this, IndexWrapper);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "goToPage", function (page) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.setState({
                    loading: false
                  });

                  _this.setState({
                    currentPage: page - 1
                  });

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _this.state = {
      currentPage: 0,
      loading: true,
      user: {
        firstName: '',
        lastName: '',
        email: '',
        userRoles: []
      },
      teamsLayout: _this.inIframe()
    };
    _this.token = null;
    return _this;
  }

  _createClass(IndexWrapper, [{
    key: "inIframe",
    value: function inIframe() {
      try {
        return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
      } catch (e) {
        return true;
      }
    }
    /**
     * Method to add Products and Services for Haldor Planning
     */

  }, {
    key: "CheckIfPlanningAndSetServices",
    value: function CheckIfPlanningAndSetServices(tenantId) {
      var _this2 = this;

      var id = getEnvironment().id;

      if (id == 'haldor_planning') {
        var tenantServices = [];
        var selectedProducts = [];
        var productDashboard = this.props.products.find(function (product) {
          return product.name === "Haldor Dashboard";
        });
        selectedProducts.push(productDashboard);
        productDashboard.services.forEach(function (service) {
          if (!tenantServices.find(function (service) {
            return service.ServiceId == service.id;
          })) {
            tenantServices.push({
              ServiceId: service.id
            });
          }
        });
        var productPlanning = this.props.products.find(function (product) {
          return product.name === "Haldor Planning";
        });
        selectedProducts.push(productPlanning);
        productPlanning.services.forEach(function (service) {
          if (!tenantServices.find(function (service) {
            return service.ServiceId == service.id;
          })) {
            tenantServices.push({
              ServiceId: service.id
            });
          }
        });
        this.props.updateTenantProducts(selectedProducts).then(function () {
          _this2.props.getTenantProducts();

          appInsights.trackTrace({
            message: "Onboarding H.P. | trying update tenantServices"
          }, {
            services: tenantServices,
            tenant: _this2.props.tenant
          }); // This is important since our system is depended on services

          _this2.props.createTenantServices(tenantServices).then(function () {
            //this.props.saveSelectedProductsAsNotes(false);
            _this2.props.getTenant();
          });
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      appInsights.trackTrace({
        message: "Onboarding | Initiating onboarding proccess"
      });

      if (this.inIframe()) {
        // Onboarding is depanded on following information from Database
        var promises = [this.props.userAdminCheck(), this.props.getTenant(), this.props.getAdminInvitations(), this.props.getTenantProducts(), this.props.getServices(), this.props.getBaseMe()];
        appInsights.trackTrace({
          message: "Onboarding | User is using Teams and preparing to get user consent"
        });
        microsoftTeams.app.getContext().then(function (context) {
          _this3.retrieveUser(context);

          Promise.all(promises).then(function () {
            appInsights.trackTrace({
              message: "Onboarding | Checking if tenant information is present in our database"
            }, {
              tenant: _this3.props.tenant
            });

            _this3.CheckIfPlanningAndSetServices(context.user.tenant.id);

            if (_this3.props.tenant == null || _this3.props.tenant == "") {
              var tenantDomain = null;

              if (context.user.userPrincipalName != null && context.user.userPrincipalName.indexOf("@") > -1) {
                tenantDomain = context.user.userPrincipalName.substring(context.user.userPrincipalName.indexOf("@") + 1).toLowerCase();
              }

              if (tenantDomain == null && context.user.userPrincipalName.indexOf("@") > -1) {
                tenantDomain = context.user.loginHint.substring(context.user.userPrincipalName.indexOf("@") + 1).toLowerCase();
              }

              var tenant = {
                title: "",
                tenantId: context.user.tenant.id,
                tenantDomain: tenantDomain,
                tenantSPOUrl: "https://" + context.sharePointSite.teamSiteDomain,
                lcid: context.app.locale
              };
              appInsights.trackTrace({
                message: "Onboarding | Trying to save tenant information in our database"
              }, {
                tenant: tenant
              });

              _this3.props.createTenant(tenant).then(function () {
                appInsights.trackTrace({
                  message: "Onboarding | Trying to save user information in our database"
                });

                _this3.props.addUser(_this3.state.user).then(function () {
                  _this3.setState({
                    loading: false
                  });
                });
              });
            } else {
              if (!_this3.props.currentUser) {
                appInsights.trackTrace({
                  message: "Onboarding | New user in tenant are using onboarding, saving user information in our database"
                });

                _this3.props.addUser(_this3.state.user).then(function () {
                  _this3.setState({
                    loading: false
                  });
                });
              }

              if (_this3.props.tenant.contactEmail == null) {
                appInsights.trackTrace({
                  message: "Onboarding | ConactEmail is missing in tenant, trying to update tenant"
                });

                _this3.props.updateTenant(_this3.props.tenant);
              }
            }

            _this3.navigateToSpecificPage();
          });
        });
      } else {
        appInsights.trackTrace({
          message: "Onboarding | User is not using Teams and preparing to get user consent"
        });
        this.props.getBaseMe().then(function () {
          var promises = [_this3.props.userAdminCheck(), _this3.props.getTenant(), _this3.props.getAdminInvitations(), _this3.props.getTenantProducts(), _this3.props.getServices()];
          Promise.all(promises).then(function () {
            appInsights.trackTrace({
              message: "Onboarding | Checking if tenant information is present in our database"
            }, {
              tenant: _this3.props.tenant
            });

            if (_this3.props.tenant == null || _this3.props.tenant == "") {
              var tenantDomain = null;

              if (tenantDomain == null && _this3.props.onboardingUser.email.indexOf("@") > -1) {
                tenantDomain = _this3.props.onboardingUser.email.substring(_this3.props.onboardingUser.email.indexOf("@") + 1).toLowerCase();
              }

              var tenant = {
                title: "",
                tenantId: _this3.props.onboardingUser.tenantId,
                tenantDomain: tenantDomain,
                tenantSPOUrl: "",
                lcid: ""
              };
              appInsights.trackTrace({
                message: "Onboarding | Trying to save tenant information in our database"
              }, {
                tenant: tenant
              });

              _this3.props.createTenant(tenant).then(function () {
                appInsights.trackTrace({
                  message: "Onboarding | Trying to save user information in our database"
                });

                _this3.props.addUser(_this3.props.onboardingUser).then(function () {
                  _this3.setState({
                    loading: false
                  });

                  _this3.navigateToSpecificPage();
                });
              });
            } else {
              if (!_this3.props.currentUser) {
                appInsights.trackTrace({
                  message: "Onboarding | New user in tenant are using onboarding, saving user information in our database"
                });

                _this3.props.addUser(_this3.props.onboardingUser).then(function () {
                  _this3.setState({
                    loading: false
                  });

                  _this3.navigateToSpecificPage();
                });
              } else {
                _this3.navigateToSpecificPage();
              }
            }
          });
        });
      }
    }
    /**
     * @description User will be navigated to the proper page based on the url
     */

  }, {
    key: "navigateToSpecificPage",
    value: function navigateToSpecificPage() {
      this.setState({
        loading: false
      });

      if (window.location.search.indexOf('admin') > -1) {
        this.goToPage(2);
      }
    }
    /**
     * @description This method is used to retrieve user information based on Teams Context
     * @param {Object} context 
     */

  }, {
    key: "retrieveUser",
    value: function retrieveUser(context) {
      if (context.user.userPrincipalName) {
        var user = this.state.user;
        user.email = context.user.userPrincipalName;
        user.firstName = context.user.userPrincipalName.split('@')[0];

        if (user.firstName.indexOf(".") > -1) {
          var firstName = user.firstName.split('.')[0];
          var lastName = user.firstName.split('.')[1];
          user.firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
          user.lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);
        }
      }

      if (context.user.licenseType != null) {
        user.userRoles.push(context.user.licenseType);
      }

      this.setState({
        user: user
      });
    }
  }, {
    key: "submit",
    value: function submit(event) {
      this.setState({
        loading: false
      });
      this.goToPage(2);
      return;
    }
    /**
     * @description Take user to particular page within the onboarding process
     * @param {*} page 
     * @returns 
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var product = getEnvironment().id;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          background: '#FFF',
          marginLeft: 'auto',
          marginRight: 'auto',
          width: this.state.teamsLayout ? '100%' : '80%',
          paddingTop: '3%',
          paddingBlockStart: '3%',
          height: '-webkit-fill-available'
        }
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : product == 'haldor_planning' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Wizard, {
        disableWizardStepNavigation: true,
        currentPage: this.state.currentPage,
        goToPage: function goToPage(i) {
          _this4.goToPage(i);
        }
      }, /*#__PURE__*/React.createElement(WizardStep, {
        name: "1"
      }, /*#__PURE__*/React.createElement(ConsentManager, {
        onSubmit: this.goToPage
      })), /*#__PURE__*/React.createElement(WizardStep, {
        name: "2"
      }, /*#__PURE__*/React.createElement(TermsManagemant, {
        onSubmit: this.goToPage
      })), /*#__PURE__*/React.createElement(WizardStep, {
        name: "3"
      }, /*#__PURE__*/React.createElement(ConsentConfirm, {
        onSubmit: this.goToPage
      })))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Wizard, {
        disableWizardStepNavigation: true,
        currentPage: this.state.currentPage,
        goToPage: function goToPage(i) {
          _this4.goToPage(i);
        }
      }, /*#__PURE__*/React.createElement(WizardStep, {
        name: "1"
      }, /*#__PURE__*/React.createElement(ServiceSelector, {
        onSubmit: this.goToPage
      })), /*#__PURE__*/React.createElement(WizardStep, {
        name: "2"
      }, /*#__PURE__*/React.createElement(ConsentManager, {
        onSubmit: this.goToPage
      })), /*#__PURE__*/React.createElement(WizardStep, {
        name: "3"
      }, /*#__PURE__*/React.createElement(TermsManagemant, {
        onSubmit: this.goToPage
      })), /*#__PURE__*/React.createElement(WizardStep, {
        name: "4"
      }, /*#__PURE__*/React.createElement(ConsentConfirm, {
        onSubmit: this.goToPage
      })))));
    }
  }]);

  return IndexWrapper;
}(Component);

_defineProperty(IndexWrapper, "contextTypes", {
  router: PropTypes.object
});

function mapStateToProps(state) {
  return {
    currentUser: state.user.currentBaseUser,
    onboardingUser: state.user.onboardingUser,
    tenant: state.user.tenant,
    products: state.Services.availableProducts,
    adminInvitations: state.Services.adminInvitations
  };
}

export default connect(mapStateToProps, {
  getServices: getServices,
  setSelectedServices: setSelectedServices,
  createTenant: createTenant,
  createTenantServices: createTenantServices,
  getTenant: getTenant,
  addUser: addUser,
  getBaseMe: getBaseMe,
  getTenantProducts: getTenantProducts,
  userAdminCheck: userAdminCheck,
  updateTenant: updateTenant,
  updateTenantProducts: updateTenantProducts,
  getAdminInvitations: getAdminInvitations,
  setPageTitle: setPageTitle
})(reduxForm({
  form: 'AddService',
  destroyOnUnmount: true
})(IndexWrapper));